module.exports = __webpack_public_path__ + "img/settings.5f91514d.png";